import axios from 'axios';
import apiConfig from '../api.config';

export default function updateMailTemplateState({ hotelId, templateId, enabled }) {
  const {
    host,
    URIs: { updateMailTemplateStatus },
  } = apiConfig;

  const uri = `${host}${updateMailTemplateStatus}`.replace(':hotelId', hotelId);

  return axios
    .put(uri, JSON.stringify({ id: templateId, status: enabled }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
